import { doc, updateDoc } from 'firebase/firestore'
import { db } from '../firebase'

const requestRef = (uid, requestId) => doc(db, 'users', uid, 'requests', requestId)

const setRequest = {
  status: (requestId, status, uid) =>
    updateDoc(requestRef(uid, requestId), { status }),

  opened_at: (requestId, opened_at, uid) =>
    updateDoc(requestRef(uid, requestId), { opened_at }),

  payload: (requestId, payload, uid) =>
    updateDoc(requestRef(uid, requestId), { payload }),

  details: (requestId, { title, recipient }, uid) =>
    updateDoc(requestRef(uid, requestId), { title, recipient }),
}

export default setRequest
